import Api from 'App/api'

export const getEvents = Api.get({
  controller: 'events',
  action: 'list',
})

export const getEventsWithSettings = Api.get({
  controller: 'events',
  action: 'listWithSettings',
})

export const saveEventSettings = Api.post({
  controller: 'events',
  action: 'saveSettings',
})

export const saveEvent = Api.post({
  controller: 'events',
  action: 'save',
})

export const deleteEvent = Api.post({
  controller: 'events',
  action: 'delete',
})

export const saveEventImage = Api.postMultipart({
  controller: 'events',
  action: 'saveImage',
})

export const authCaptureEventPayment = Api.post({
  controller: 'payments',
  action: 'authCaptureEventPayment',
})
